import { Component } from '@angular/core';
import { EnumMeasureTypes } from '@library/store/measures/measures.interface';
import { ModulesFacade } from '@library/store/modules/modules.facade';
import { Module } from '@library/store/modules/modules.interface';
import { Room } from '@library/store/rooms/rooms.interface';
import { ControlPageCardService } from '@pages/control-page/control-page-main/control-page-dashboard/control-page-sidebar/control-page-card.service';
import { RoomTemperatureService } from '@pages/control-page/control-page-main/control-page-dashboard/control-page-sidebar/sidebar-rooms/sidebar-room-card/room-temperature/room-temperature.service';
import { SidebarRoomService } from '@pages/control-page/control-page-main/control-page-dashboard/control-page-sidebar/sidebar-rooms/sidebar-room-card/sidebar-room.service';
import { ControlPageStore, GraphType } from '@pages/control-page/control-page-store.service';
import { Enums } from 'constants/Enums.constant';
import { combineLatest, firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-room-temperature',
  templateUrl: './room-temperature.component.html',
  styleUrls: ['./room-temperature.component.scss']
})
export class RoomTemperatureComponent {

  private display$ = this.roomTemperatureService.display$;
  private module$ = this.roomTemperatureService.module$;

  viewModel$ = combineLatest({
    unreachable: this.roomTemperatureService.unreachable$,
    display: this.display$,
    module: this.module$,
    modules: this.modulesFacade.modules$,
    room: this.sidebarRoomService.room$,
    card: this.controlPageStore.card$,
  });

  EnumMeasureTypes = EnumMeasureTypes;
  GraphType = GraphType;

  constructor(
    public sidebarRoomService: SidebarRoomService,
    private controlPageCardService: ControlPageCardService,
    private controlPageStore: ControlPageStore,
    private modulesFacade: ModulesFacade,
    private roomTemperatureService: RoomTemperatureService,
  ) { }

  async selectModule(module: Module) {
    const room = await firstValueFrom(this.sidebarRoomService.room$);
    switch (module.type) {
      case Enums.ModuleType.NAMAIN:
      case Enums.ModuleType.NAMODULE1:
      case Enums.ModuleType.NAMODULE4:
        this.controlPageCardService.selectTemperature(module);
        break;
      case Enums.ModuleType.NATHERM1:
      case Enums.ModuleType.NRV:
        this.controlPageCardService.selectTherm(room);
        break;
    }
  }

  getTemperatureDisplay(module: Module, room: Room) {
    return this.roomTemperatureService.getTemperatureDisplay(module, room);
  }

}
